<template>
  <a-form
    id="components-form-demo-normal-login"
    :form="form"
    class="login-form"
    @submit="handleSubmit"
  >
    <p class="auth-title">Авторизация</p>

    <a-alert class="error" v-if="authError" type="error" :message="authError" />

    <a-form-item>
      <a-input
        v-decorator="[
          'userName',
          {
            rules: [
              {
                required: true,
                message: 'Введите email, указанный при регистрации',
              },
            ],
          },
        ]"
        placeholder="Имя пользователя или email"
      >
        <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input v-decorator="['password']" type="password" placeholder="Пароль">
        <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
      </a-input>
    </a-form-item>
    <a-form-item style="text-align: center">
      <a
        :title="`${CONFIG.supportEmail}`"
        :href="
          `mailto:${CONFIG.supportEmail}?subject=Обращение%20со%20страницы%20авторизации&body=Пожалуйста,%20укажите%20суть%20вопроса`
        "
      >
        Написать в поддержку
      </a>
    </a-form-item>
    <a-form-item>
      <a-checkbox
        v-if="false"
        v-decorator="[
          'remember',
          {
            valuePropName: 'checked',
            initialValue: true,
          },
        ]"
      >
        Запомнить меня
      </a-checkbox>
      <a class="login-form-forgot" @click="openRecoveryModal">Забыл пароль</a>
      <a-button type="primary" html-type="submit" class="login-form-button">
        Войти
      </a-button>
    </a-form-item>
    <a-modal
      :visible="recoveryModalVisible"
      :confirm-loading="recoveryLoading"
      :mask-closable="false"
      destroyOnClose
      title="Восстановление пароля"
      okText="Восстановить"
      cancelText="Отмена"
      :okButtonProps="{ props: { disabled: !isRecoveryEmailValid } }"
      @ok="submitRecovery"
      @cancel="closeRecoveryModal"
    >
      <a-form layout="vertical">
        <a-form-item
          label="Email"
          :validate-status="recoveryEmailValidateStatus"
          :help="recoveryEmailHelpText"
        >
          <a-input
            v-model="recoveryEmail"
            type="email"
            placeholder="Укажите email для восстановления"
            @blur="recoveryEmailTouched = true"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { notification } from "ant-design-vue"
import CFG from "@/config"
export default {
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: "normal_login",
    })
  },
  data: () => ({
    email: "",
    password: "",
    CONFIG: CFG,
    recoveryModalVisible: false,
    recoveryEmail: "",
    recoveryLoading: false,
    recoveryEmailTouched: false,
  }),
  computed: {
    ...mapGetters({
      authError: "auth/authError",
      userRole: "auth/userRole",
      user: "auth/user",
      rolesRoutes: "auth/rolesHomeRoute",
    }),
    isRecoveryEmailValid() {
      const value = (this.recoveryEmail || "").trim()
      if (!value) return false
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
      return emailRegex.test(value)
    },
    recoveryEmailValidateStatus() {
      if (!this.recoveryEmailTouched) return ""
      return this.isRecoveryEmailValid ? "success" : "error"
    },
    recoveryEmailHelpText() {
      if (!this.recoveryEmailTouched) return ""
      return this.isRecoveryEmailValid ? "" : "Введите корректный email"
    },
  },
  methods: {
    openRecoveryModal(e) {
      if (e && e.preventDefault) e.preventDefault()
      // Prefill from login field if present
      this.form.validateFields((err, values) => {
        if (!err && values && values.userName) {
          this.recoveryEmail = values.userName
        }
        this.recoveryModalVisible = true
        this.recoveryEmailTouched = false
      })
    },
    closeRecoveryModal() {
      this.recoveryModalVisible = false
      this.recoveryLoading = false
    },
    submitRecovery() {
      this.recoveryEmailTouched = true
      if (!this.isRecoveryEmailValid) {
        notification.error({
          message: "Восстановление пароля",
          description: "Укажите корректный email",
        })
        return
      }
      this.recoveryLoading = true
      const params = { email: this.recoveryEmail }
      this.passwordRecovery(params)
        .then(response => {
          const msg = response && response.data && response.data.message
          if (response.data.success == true) {
            notification.success({
              message: "Восстановление пароля",
              description: msg || "Если email существует, ссылка отправлена",
            })
          } else {
            notification.error({
              message: "Восстановление пароля",
              description: msg,
            })
          }
        })
        .catch(error => {
          const msg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            "Произошла ошибка. Попробуйте позже"
          notification.error({
            message: "Восстановление пароля",
            description: msg,
          })
        })
        .finally(() => {
          this.recoveryLoading = false
          this.recoveryModalVisible = false
        })
    },
    ...mapActions({
      login: "auth/login",
      passwordRecovery: "auth/passwordRecovery",
    }),
    async handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.login({
            login: values.userName,
            password: values.password,
          }).then(() => {
            const script = document.createElement("script")
            script.id = "quiz-widget"
            script.src =
              "https://litenps.smartconsulting.pro/quizjs.min.js?email=" +
              this.user.email +
              "&id=2"
            document.head.appendChild(script)
            if (document.getElementById("quiz-start"))
              document.getElementById("quiz-start").style.display = "flex"

            const roleHomeRoute = this.rolesRoutes[this.userRole]
            console.info("user role:", this.userRole)
            if (this.userRole !== null) {
              this.$router.push(roleHomeRoute)
            } else {
              this.$router.push("/403")
            }
            //this.$router.push(this.rolesRoutes[role] ?? "/")
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}

#components-form-demo-normal-login .login-form-forgot {
  float: right;
}

#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
</style>

<style lang="scss" scoped>
.error {
  margin-bottom: 20px;
}

.auth-title {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-family: $fontf-main;
  font-weight: 500;
}
</style>
